import { render } from "./adminlist.vue?vue&type=template&id=850cdea8"
import script from "./adminlist.vue?vue&type=script&lang=js"
export * from "./adminlist.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__